import { useEffect, useMemo, useState } from "react";
import parse from "html-react-parser";
import Image from "components/Elements/Image/Image.tsx";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import config from "config";
import ToastHtmlComponent from "../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import LoadingContainerElement from "components/Elements/LoadingContainerElement/LoadingContainerElement.js";
import Form from "components/Reusable/Form/Form.js";
import emailPreferencesFormFields from "./emailPreferencesFormFields.tsx";
import { useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";

import "./EmailPreferences.scss";

const EmailPreferences = () => {
  const { token } = useParams();
  const { isTokenExist } = useUser();
  const { getPageText, getTextByKey, getHtmlByKey, getPath } = useContent();
  const { addToast } = useToasts();

  const [details, setDetails] = useState(null);

  const getUserSettings = async () => {
    const res = await apiRequest(
      "Users",
      "GetUserNotificationSettingsByEncryptUid",
      {
        uid: token,
      }
    );

    if (res.status === "success") {
      setDetails(res.data);
    }
  };

  const updateNotifications = async (formBody) => {
    const body = {
      ...formBody,
      UserEncryptedEmail: token,
      // captchaServiceName: "cloudflare",
    };
    const response = await apiRequest(
      "Users",
      "UpdateEmailPreferences",
      body,
      "POST"
    );
    if (response.status === "success") {
      addToast(getTextByKey("email-preferences-updated-Success"), {
        appearance: "success",
      });
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", 1305178);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
  };

  useEffect(() => {
    if (token !== undefined) {
      getUserSettings();
    }
  }, []);

  useMemo(() => {
    if (isTokenExist) {
      let newPage =
        config.baseurl + getPath() + "user/profile/account-settings";
      window.location.href = newPage;
    }
  }, [isTokenExist]);

  return (
    <div className="email-preferences-container">
      <div className="page-header">
        <h1>{getTextByKey("email-preferences-title")}</h1>
        <div className="title-divider"></div>{" "}
        <h3>
          {getTextByKey("email-preferences-sub-title1")}{" "}
          <b>{details?.UserEmail}</b>
        </h3>
        <h5>{getTextByKey("email-preferences-sub-title2")}</h5>
        <div className="header-decorations">
          <Image
            className="cloud-1"
            name="clouds-left"
            alt="clouds-left"
            ext="png"
          />
          <Image
            className="cloud-2"
            name="clouds-right"
            alt="clouds-right"
            ext="png"
          />
        </div>
      </div>
      <div className={`page-body`}>
        {details ? (
          <>
            <div className="text-page">
              {getPageText().TextBox && parse(getPageText().TextBox)}
            </div>
            <Form
              fields={emailPreferencesFormFields}
              onSubmit={updateNotifications}
              submitProps={{
                title: getTextByKey("email-preferences-submit-button"),
                className: "submit-button",
              }}
              defaultValuesObj={{
                NotificationsAlertBeforeDeletion:
                  details.NotificationsAlertBeforeDeletion,
                UserReceiveRecipientAlertDelete:
                  details.UserReceiveRecipientAlertDelete,
                NotificationsMarketing: details.NotificationsMarketing,
                NotificationsDownloadLink: details.NotificationsDownloadLink,
              }}
              // captchaProvider="cloudflare"
              // cloudflareActionName="updateEmailPreferences"
            />
            <div className="other-notifications-link">
              {getHtmlByKey("email-preferences-click-to-login")}
            </div>
          </>
        ) : (
          <LoadingContainerElement />
        )}
      </div>
    </div>
  );
};

export default EmailPreferences;
